const ITEMS = [
  "SHUTUP & SPEAK WILD",
  "LIMITED EDITION — 200 PIECES",
  "THE SHUTUP T-SHIRT",
  "₹2,000",
  "BLACK · OVERSIZED",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div data-testid="marquee" className="bg-acid text-black overflow-hidden border-y-2 border-black py-3 sm:py-4">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0" aria-hidden={copy === 1}>
            {row.map((t, i) => (
              <span key={i} className="flex items-center gap-6 px-6 font-sans font-bold text-sm sm:text-lg tracking-[0.12em]">
                {t} <span className="font-display text-pink">✕</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
